import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RelationsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RelationsSVG;
